(function () {
  var STORAGE_KEY = 'odhanon_wishlist';

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function findIndex(items, productId) {
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].productId) === String(productId)) return i;
    }
    return -1;
  }

  function has(productId) {
    return findIndex(readStore(), productId) !== -1;
  }

  function currencyCode() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
  }

  function trackAdd(item) {
    var value = (parseInt(item.price, 10) || 0) / 100;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_wishlist', {
          currency: currencyCode(),
          value: value,
          items: [{ item_id: item.productId, item_name: item.title, price: value }]
        });
      }
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToWishlist', {
          content_ids: [String(item.productId)],
          content_name: item.title,
          content_type: 'product',
          value: value,
          currency: currencyCode()
        });
      }
    } catch (e) {}
  }

  function add(item) {
    var items = readStore();
    var idx = findIndex(items, item.productId);
    if (idx === -1) {
      item.addedAt = Date.now();
      items.unshift(item);
      writeStore(items);
      trackAdd(item);
    }
    return items;
  }

  function remove(productId) {
    var items = readStore();
    var idx = findIndex(items, productId);
    if (idx !== -1) {
      items.splice(idx, 1);
      writeStore(items);
    }
    return items;
  }

  function toggle(item) {
    if (has(item.productId)) {
      remove(item.productId);
      return false;
    }
    add(item);
    return true;
  }

  function updateVariant(productId, variant) {
    var items = readStore();
    var idx = findIndex(items, productId);
    if (idx === -1) return items;
    items[idx].variantId = variant.id;
    items[idx].variantTitle = variant.title;
    items[idx].price = variant.price;
    writeStore(items);
    return items;
  }

  function itemFromButton(btn) {
    return {
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id'),
      variantTitle: btn.getAttribute('data-variant-title'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      url: btn.getAttribute('data-product-url')
    };
  }

  function refreshButtons() {
    var items = readStore();
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var productId = btn.getAttribute('data-product-id');
      var active = findIndex(items, productId) !== -1;
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) {
        label.textContent = active ? (btn.getAttribute('data-label-remove') || 'In Wishlist') : (btn.getAttribute('data-label-add') || 'Add to Wishlist');
      }
    }
    var counts = document.querySelectorAll('[data-wishlist-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = items.length;
      counts[j].setAttribute('data-total', items.length);
      var badge = counts[j].closest('.cart-count') || counts[j];
      badge.hidden = items.length === 0;
    }
  }

  function showToast(message) {
    var container = document.querySelector('[data-wishlist-toast-container]');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.textContent = message;
    container.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.remove();
      }, 250);
    }, 2200);
  }

  function refreshCartUI() {
    var drawer = document.getElementById('CartDrawer');
    var sectionId = drawer && drawer.getAttribute('data-section-id');
    if (sectionId) {
      fetch('/?section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var fresh = tmp.querySelector('#CartDrawer');
          if (fresh && drawer.parentNode) drawer.parentNode.replaceChild(fresh, drawer);
        })
        .catch(function () {});
    }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('#CartCount').forEach(function (el) {
          el.innerHTML = cart.item_count > 0
            ? '<div class="cart-count' + (cart.item_count > 9 ? ' cart-count--ellipse' : '') + '"><span aria-hidden="true">' + cart.item_count + '</span></div>'
            : '';
        });
      })
      .catch(function () {});
  }

  function moveToCart(item, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: item.variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function () {
        remove(item.productId);
        refreshButtons();
        showToast((item.title || 'Item') + ' moved to cart');
        refreshCartUI();
        if (typeof onDone === 'function') onDone(true);
      })
      .catch(function () {
        showToast('Could not move this item to cart. It may be sold out.');
        if (typeof onDone === 'function') onDone(false);
      });
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var item = itemFromButton(toggleBtn);
      var nowActive = toggle(item);
      refreshButtons();
      showToast(nowActive ? (item.title || 'Item') + ' added to wishlist' : (item.title || 'Item') + ' removed from wishlist');
      if (nowActive) renderWishlistPage();
      return;
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.getAttribute('data-product-id'));
      refreshButtons();
      renderWishlistPage();
      return;
    }

    var moveBtn = e.target.closest('[data-wishlist-move-to-cart]');
    if (moveBtn) {
      e.preventDefault();
      moveBtn.setAttribute('disabled', 'disabled');
      var moveItem = {
        productId: moveBtn.getAttribute('data-product-id'),
        variantId: moveBtn.getAttribute('data-variant-id'),
        title: moveBtn.getAttribute('data-product-title')
      };
      moveToCart(moveItem, function () {
        renderWishlistPage();
      });
      return;
    }

    var moveAllBtn = e.target.closest('[data-wishlist-move-all-to-cart]');
    if (moveAllBtn) {
      e.preventDefault();
      var items = readStore().slice();
      (function next(i) {
        if (i >= items.length) {
          renderWishlistPage();
          return;
        }
        moveToCart(items[i], function () {
          next(i + 1);
        });
      })(0);
    }
  });

  function escapeHtml(str) {
    return (str || '').toString().replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode(),
        minimumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function findSizeOption(product) {
    if (!product || !product.options) return null;
    for (var i = 0; i < product.options.length; i++) {
      if ((product.options[i].name || '').toLowerCase() === 'size') {
        return { key: 'option' + product.options[i].position, values: product.options[i].values };
      }
    }
    return null;
  }

  function findVariantForSize(product, currentVariant, sizeOption, newValue) {
    for (var i = 0; i < product.variants.length; i++) {
      var candidate = product.variants[i];
      if (candidate[sizeOption.key] !== newValue) continue;
      var matchesOtherOptions = true;
      for (var o = 0; o < product.options.length; o++) {
        var key = 'option' + product.options[o].position;
        if (key === sizeOption.key) continue;
        if (candidate[key] !== currentVariant[key]) {
          matchesOtherOptions = false;
          break;
        }
      }
      if (matchesOtherOptions) return candidate;
    }
    return null;
  }

  function applyVariantToCard(card, item, variant, available) {
    var price = variant ? variant.price : item.price;
    var variantId = variant ? variant.id : item.variantId;
    var title = card.querySelector('.wishlist-item__title').textContent;

    card.querySelector('.wishlist-item__price').textContent = formatMoney(price);

    var soldOut = card.querySelector('.wishlist-item__sold-out');
    if (soldOut) soldOut.hidden = available;

    var moveBtn = card.querySelector('[data-wishlist-move-to-cart]');
    if (moveBtn) {
      moveBtn.setAttribute('data-variant-id', variantId);
      moveBtn.disabled = !available;
      moveBtn.textContent = available ? 'Move to cart' : 'Sold out';
    }
  }

  function renderItemCard(item) {
    var title = item.title;
    var image = item.image;
    var price = item.price;
    var url = item.url;
    var variantTitle = item.variantTitle;
    var showVariant = variantTitle && variantTitle !== 'Default Title';

    var card = document.createElement('div');
    card.className = 'wishlist-item';
    card.innerHTML =
      '<a class="wishlist-item__media" href="' + escapeHtml(url) + '">' +
        (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy" width="200" height="200">' : '') +
      '</a>' +
      '<div class="wishlist-item__details">' +
        '<a class="wishlist-item__title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>' +
        '<div class="wishlist-item__size-slot">' +
          (showVariant ? '<div class="wishlist-item__variant">Size: ' + escapeHtml(variantTitle) + '</div>' : '') +
        '</div>' +
        '<div class="wishlist-item__price">' + formatMoney(price) + '</div>' +
        '<div class="wishlist-item__sold-out" hidden>Sold out</div>' +
        '<div class="wishlist-item__actions">' +
          '<button type="button" class="btn btn--sm btn--primary" data-wishlist-move-to-cart data-product-id="' + escapeHtml(item.productId) + '" data-variant-id="' + escapeHtml(item.variantId) + '" data-product-title="' + escapeHtml(title) + '">Move to cart</button>' +
          '<button type="button" class="btn btn--sm btn--secondary" data-wishlist-remove data-product-id="' + escapeHtml(item.productId) + '">Remove</button>' +
        '</div>' +
      '</div>';

    return card;
  }

  function enhanceItemCard(card, item, product) {
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(item.variantId)) {
        variant = product.variants[i];
        break;
      }
    }
    if (!variant) variant = product.variants[0];

    applyVariantToCard(card, item, variant, variant.available);

    var sizeOption = findSizeOption(product);
    if (!sizeOption) return;

    var slot = card.querySelector('.wishlist-item__size-slot');
    var optionsHtml = sizeOption.values.map(function (value) {
      var selected = value === variant[sizeOption.key] ? ' selected' : '';
      return '<option value="' + escapeHtml(value) + '"' + selected + '>' + escapeHtml(value) + '</option>';
    }).join('');
    slot.innerHTML =
      '<label class="wishlist-item__size-field">' +
        '<span class="wishlist-item__size-label">Size</span>' +
        '<select class="wishlist-item__size-select" data-wishlist-size-select data-product-id="' + escapeHtml(item.productId) + '">' +
          optionsHtml +
        '</select>' +
      '</label>';

    var select = slot.querySelector('[data-wishlist-size-select]');
    select.addEventListener('change', function () {
      var newVariant = findVariantForSize(product, variant, sizeOption, select.value);
      if (!newVariant) return;
      variant = newVariant;
      updateVariant(item.productId, newVariant);
      applyVariantToCard(card, item, newVariant, newVariant.available);
      showToast('Size updated to ' + newVariant[sizeOption.key]);
    });
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-grid]');
    if (!root) return;
    var items = readStore();
    var empty = document.querySelector('[data-wishlist-empty]');
    var moveAllBtn = document.querySelector('[data-wishlist-move-all-to-cart]');

    if (items.length === 0) {
      root.innerHTML = '';
      root.hidden = true;
      if (empty) empty.hidden = false;
      if (moveAllBtn) moveAllBtn.hidden = true;
      return;
    }

    root.hidden = false;
    if (empty) empty.hidden = true;
    if (moveAllBtn) moveAllBtn.hidden = false;

    root.innerHTML = '';
    items.forEach(function (item) {
      var card = renderItemCard(item);
      root.appendChild(card);
      if (!item.handle) return;
      fetch('/products/' + item.handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then(function (product) {
          enhanceItemCard(card, item, product);
        })
        .catch(function () {});
    });
  }

  refreshButtons();
  renderWishlistPage();

  window.OdhanonWishlist = {
    getAll: readStore,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    refresh: refreshButtons
  };
})();
